import {find} from "lodash"
import {UserOnboarding} from "@irati/types"
import OnboardingStep from "../enums/Step"

export default function shouldRedirectToGDPR({completedSteps}: UserOnboarding) {
  const hasDoneGDPRStep = find(completedSteps, (step) => step === OnboardingStep.ACCEPT_GDPR)
  return !hasDoneGDPRStep
}
